import { accountService } from '@libs/data-access/queries'
import { isValidTime } from '@spa/components/FormFields/helpers'
import moment from 'moment'

import { computeShiftDates } from '../../utils'
import type FormData from '../Models/FormData'

type Props = {
  contractEnd?: string
  date?: string
  shiftTimeRange: FormData['shift_time_range']
}
export const useDisplayEndContractOverrunWarning = ({
  contractEnd,
  date,
  shiftTimeRange
}: Props) => {
  const { data } = accountService.countryConfiguration.useFetch()

  // handling undefined for unassigned case
  if (!contractEnd || !date) {
    return false
  }
  const { endDate } = computeShiftDates(shiftTimeRange, moment(date))
  const contractEndMoment = moment(contractEnd).endOf('d').add(1, 'm')

  const [start_at, end_at] = shiftTimeRange
  const isValidTimes = isValidTime(start_at) && isValidTime(end_at)

  if (
    data?.iso_code !== 'ES' &&
    isValidTimes &&
    contractEndMoment.isBefore(endDate)
  ) {
    return true
  }

  return false
}
